import { Component, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { UserService } from '@features/user/services/user.service';

@Component({
    selector: 'app-impersonation-banner',
    templateUrl: './impersonation-banner.component.html',
})
export class ImpersonationBannerComponent {
    private userService = inject(UserService);

    impersonatedUser = toSignal(this.userService.fetch_user());
}
